const css = `.routine-panel .routine-form {
  padding-bottom: calc(var(--space-8) + var(--space-6));
}
.routine-panel .routine-panel-header {
  display: flex;
  align-items: center;
  gap: 16px;
}
.routine-panel .routine-panel-header .p-button-icon-only {
  width: fit-content;
}
.routine-panel .routine-panel-header h4 {
  margin-right: 12px;
}
.routine-panel .routine-user-container {
  display: flex;
  align-items: center;
  column-gap: 24px;
  flex-wrap: wrap;
}
.routine-panel .routine-user-container .p-button-link {
  margin-left: 12px;
}
.routine-panel .copy-routine {
  display: flex;
  gap: 16px;
  align-items: center;
  flex-wrap: wrap;
}
.routine-panel .add-exercise-button {
  margin-top: 16px;
  margin-left: auto;
}
.routine-panel .days-elapsed-container {
  min-height: 48px;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
  padding-left: 12px;
  text-wrap: nowrap;
  font-weight: var(--font-weight-medium);
}
.routine-panel .days-elapsed-container .days-info {
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1;
}
.routine-panel .days-elapsed-container .p-tag {
  margin: 0;
}
.routine-panel .days-elapsed-container .progress-container {
  width: 100%;
  max-width: 150px;
}
.routine-panel .days-elapsed-container .days-elapsed-message {
  display: flex;
  align-items: center;
  gap: 4px;
  font-weight: var(--font-weight-semibold);
}
.routine-panel .days-elapsed-container .days-elapsed-message i {
  font-weight: var(--font-weight-bold);
}
.routine-panel .days-elapsed-container .days-elapsed-message.error {
  color: var(--danger);
}
.routine-panel .days-elapsed-container .days-elapsed {
  width: 112px;
}
.routine-panel .finish-routine-button {
  width: fit-content;
  margin-left: 4px;
}
.routine-panel .ending-soon-container {
  display: flex;
  padding-left: 12px;
  align-items: center;
  gap: 8px;
  font-size: var(--font-size-xs);
  font-weight: var(--font-weight-medium);
}
.routine-panel .ending-soon-container.warning {
  color: var(--warning);
}
.routine-panel .ending-soon-container.error {
  color: var(--danger);
}
.routine-panel .ending-soon-container i {
  font-weight: var(--font-weight-semibold);
}
.routine-panel .routine-dates {
  font-size: var(--font-size-xs);
  padding-left: 12px;
}
.routine-panel .routine-dates i {
  margin-right: 8px;
}
.routine-panel .routine-description-field {
  min-height: 60px;
}
.routine-panel .routine-description-field p {
  margin: 8px 0;
}
.routine-panel .exercise-days-container {
  display: flex;
  flex-direction: column;
  gap: 12px;
  position: relative;
  width: 100%;
}
.routine-panel .exercise-days-container .exercise-days-filters {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
}
.routine-panel .exercise-days-container .exercise-days-muscle-groups-filter,
.routine-panel .exercise-days-container .exercise-days-categories-filter {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 300px;
}
.routine-panel .exercise-days-container .exercise-days-muscle-groups-filter .p-multiselect,
.routine-panel .exercise-days-container .exercise-days-categories-filter .p-multiselect {
  min-width: 300px;
  padding: var(--space-2) 0 var(--space-2) var(--space-4);
}
.routine-panel .exercise-days-container .exercise-days-muscle-groups-filter .p-multiselect .p-multiselect-label,
.routine-panel .exercise-days-container .exercise-days-categories-filter .p-multiselect .p-multiselect-label {
  font-size: var(--font-size-xs);
}
.routine-panel .exercise-days-container .exercise-days-muscle-groups-filter .adaptive-select-trigger,
.routine-panel .exercise-days-container .exercise-days-categories-filter .adaptive-select-trigger {
  min-width: 300px;
}
.routine-panel .exercise-days-container .exercise-days-edit-container {
  width: 100%;
  position: relative;
  margin-bottom: 0;
}
.routine-panel .exercise-days-container .exercise-days-view-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 12px;
  width: 100%;
  padding: 8px;
  border: 2px dashed transparent;
  border-radius: var(--border-radius);
  position: relative;
  transition: gap 0.3s ease;
}
@media screen and (max-width: 1400px) {
  .routine-panel .exercise-days-container .exercise-days-view-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}
@media screen and (max-width: 1100px) {
  .routine-panel .exercise-days-container .exercise-days-view-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media screen and (max-width: 768px) {
  .routine-panel .exercise-days-container .exercise-days-view-grid {
    grid-template-columns: 1fr;
  }
}
.routine-panel .exercise-days-container .exercise-days-view-grid.is-dragging-over {
  border-color: var(--primary-color);
  background-color: var(--accent-subtle);
  gap: var(--space-5);
}
.routine-panel .exercise-days-container .no-days-message {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 24px;
  text-align: center;
  background-color: var(--danger-subtle);
  border: 1px solid var(--danger);
  border-radius: var(--border-radius);
}
.routine-panel .exercise-days-container .no-days-message i {
  font-size: var(--font-size-2xl);
  color: var(--danger);
}
.routine-panel .exercise-days-container .no-days-message p {
  color: var(--danger);
  font-size: var(--font-size-base);
  margin: 0;
}
.routine-panel .exercise-days-container .p-orderlist {
  display: flex;
  flex-direction: column;
}
.routine-panel .exercise-days-container .p-orderlist .p-orderlist-header {
  background: var(--surface-sunken);
  color: var(--text);
  padding: var(--space-3);
  font-weight: var(--font-weight-semibold);
  border-bottom: 1px solid var(--border);
  border-radius: 6px;
  margin-bottom: 12px;
  font-size: var(--font-size-sm);
}
.routine-panel .exercise-days-container .p-orderlist .p-orderlist-list {
  display: grid;
  grid-template-columns: 1fr;
  gap: 12px;
  width: 100%;
  padding: 0;
  height: auto !important;
  min-height: 0 !important;
  max-height: none !important;
  overflow: visible !important;
  border: none;
  background-color: transparent;
}
@media screen and (min-width: 768px) {
  .routine-panel .exercise-days-container .p-orderlist .p-orderlist-list {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media screen and (min-width: 1200px) {
  .routine-panel .exercise-days-container .p-orderlist .p-orderlist-list {
    grid-template-columns: repeat(3, 1fr);
  }
}
.routine-panel .exercise-days-container .p-orderlist .p-orderlist-controls {
  padding: 12px;
  display: flex;
  flex-direction: row;
  gap: 8px;
  justify-content: center;
}
.routine-panel .exercise-days-container .p-orderlist .p-orderlist-controls .p-button {
  width: 36px;
  height: 36px;
  background: var(--accent);
  border: 1px solid var(--accent);
  color: var(--accent-text);
}
.routine-panel .exercise-days-container .p-orderlist .p-orderlist-controls .p-button:enabled:hover {
  background: var(--accent-hover);
  border-color: var(--accent-hover);
}
.routine-panel .exercise-days-container .p-orderlist .p-orderlist-controls .p-button:focus {
  box-shadow: none;
}
.routine-panel .exercise-days-container .p-orderlist .p-orderlist-controls .p-button.p-button-icon-only {
  padding: 0;
}
.routine-panel .exercise-days-container .p-orderlist .p-orderlist-item {
  padding: 0;
  margin: 0;
  border: none;
  background: transparent;
  overflow: visible;
}
.routine-panel .exercise-days-container .p-orderlist .p-orderlist-item:not(:last-child) {
  margin-bottom: 8px;
}
.routine-panel .exercise-days-container .p-orderlist .p-orderlist-item:focus {
  box-shadow: none;
  outline: none;
}
.routine-panel .exercise-days-container .p-orderlist .p-orderlist-item.p-highlight .exercise-day-item {
  border-color: var(--accent);
  box-shadow: 0 0 0 2px var(--surface-raised), 0 0 0 4px var(--ring);
}
.routine-panel .exercise-days-container .exercise-day-item {
  background: var(--surface-card);
  border: 1px solid var(--surface-border);
  border-radius: var(--border-radius);
  overflow: hidden;
  margin-bottom: 8px;
  box-shadow: var(--shadow-2);
  transition: box-shadow 0.2s;
  min-height: 150px;
  display: flex;
  flex-direction: column;
}
.routine-panel .exercise-days-container .exercise-day-item:hover {
  box-shadow: var(--shadow-3);
}
.routine-panel .exercise-days-container .exercise-day-item.p-invalid {
  border-color: var(--danger);
}
.routine-panel .exercise-days-container .exercise-day-item .exercise-day-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: var(--space-2) var(--space-3);
  background-color: var(--accent-subtle);
  border-bottom: 1px solid var(--surface-border);
  border-top-left-radius: var(--border-radius);
  border-top-right-radius: var(--border-radius);
}
.routine-panel .exercise-days-container .exercise-day-item .exercise-day-header .day-info {
  display: flex;
  align-items: center;
  gap: 8px;
}
.routine-panel .exercise-days-container .exercise-day-item .exercise-day-header .day-info .day-number {
  font-weight: var(--font-weight-semibold);
  color: var(--accent);
  font-size: var(--font-size-xs);
}
.routine-panel .exercise-days-container .exercise-day-item .exercise-day-header .day-info .exercise-count {
  text-wrap: nowrap;
  color: var(--text-color-secondary);
  font-size: var(--font-size-xs);
}
.routine-panel .exercise-days-container .exercise-day-item .exercise-day-header .day-info .day-name-edit {
  font-weight: var(--font-weight-semibold);
  color: var(--accent);
  font-size: var(--font-size-xs);
  min-width: 120px;
  height: 28px;
  padding: 4px 8px;
  margin: 0;
}
.routine-panel .exercise-days-container .exercise-day-item .exercise-day-header .day-info .day-name-edit:focus {
  box-shadow: 0 0 0 1px var(--border-strong);
  border-color: var(--border-strong);
}
.routine-panel .exercise-days-container .exercise-day-item .exercise-day-header .day-actions {
  display: flex;
  gap: var(--space-2);
}
.routine-panel .exercise-days-container .exercise-day-item .exercise-day-header .day-actions .small-button {
  width: 24px;
  height: 24px;
}
.routine-panel .exercise-days-container .exercise-day-item .exercise-day-content {
  padding: var(--space-2) var(--space-3);
  flex: 1;
  display: flex;
  flex-direction: column;
}
.routine-panel .exercise-days-container .exercise-day-item .exercise-day-content .exercise-list {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
}
.routine-panel .exercise-days-container .exercise-day-item .exercise-day-content .exercise-item {
  position: relative;
  background: var(--surface-card);
  border: 1px solid var(--surface-border);
  border-radius: var(--border-radius);
  padding: 8px;
  margin-bottom: var(--space-2);
  transition: background-color 0.3s ease;
  z-index: revert-layer;
}
.routine-panel .exercise-days-container .exercise-day-item .exercise-day-content .exercise-item.duplicate-exercise .p-inputnumber .p-inputnumber-input {
  background-color: var(--surface-sunken);
}
.routine-panel .exercise-days-container .exercise-day-item .exercise-day-content .exercise-item.invalid-exercise {
  border-color: var(--danger);
}
.routine-panel .exercise-days-container .exercise-day-item .exercise-day-content .exercise-item:last-child {
  margin-bottom: 0;
}
.routine-panel .exercise-days-container .exercise-day-item .exercise-day-content .exercise-item.expanded {
  background-color: var(--surface-hover);
}
.routine-panel .exercise-days-container .exercise-day-item .exercise-day-content .exercise-item.expanded .exercise-header .comment-indicator {
  right: -4px;
  top: -4px;
}
.routine-panel .exercise-days-container .exercise-day-item .exercise-day-content .exercise-item .exercise-header {
  display: flex;
  align-items: center;
  gap: var(--space-2);
  position: relative;
}
.routine-panel .exercise-days-container .exercise-day-item .exercise-day-content .exercise-item .exercise-header .comment-indicator {
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  right: -6px;
  top: -4px;
}
.routine-panel .exercise-days-container .exercise-day-item .exercise-day-content .exercise-item .exercise-header .comment-indicator i {
  color: var(--accent);
  background-color: var(--surface-raised);
  font-size: var(--font-size-xs);
}
.routine-panel .exercise-days-container .exercise-day-item .exercise-day-content .exercise-item .exercise-header .exercise-info {
  flex: 1;
  min-width: 0;
}
.routine-panel .exercise-days-container .exercise-day-item .exercise-day-content .exercise-item .exercise-header .exercise-info .exercise-name {
  display: block;
  font-weight: var(--font-weight-semibold);
  color: var(--text-color);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-bottom: 0;
  font-size: var(--font-size-sm);
}
.routine-panel .exercise-days-container .exercise-day-item .exercise-day-content .exercise-item .exercise-header .exercise-actions {
  display: flex;
  gap: var(--space-2);
  margin-left: auto;
}
.routine-panel .exercise-days-container .exercise-day-item .exercise-day-content .exercise-item .exercise-header .exercise-actions .p-button {
  width: 24px;
  height: 24px;
}
.routine-panel .exercise-days-container .exercise-day-item .exercise-day-content .exercise-item .exercise-header .exercise-actions .expand-button {
  transition: transform 0.3s ease;
}
.routine-panel .exercise-days-container .exercise-day-item .exercise-day-content .exercise-item .exercise-header .exercise-actions .expand-button.expanded {
  transform: rotate(180deg);
}
.routine-panel .exercise-days-container .exercise-day-item .exercise-day-content .exercise-item .exercise-edit-panel {
  overflow: hidden;
  transition: max-height 0.3s ease, padding 0.3s ease, margin-top 0.3s ease;
}
.routine-panel .exercise-days-container .exercise-day-item .exercise-day-content .exercise-item.expanded {
  padding: 0;
}
.routine-panel .exercise-days-container .exercise-day-item .exercise-day-content .exercise-item.expanded .exercise-header {
  padding: 8px 8px 8px 8px;
}
.routine-panel .exercise-days-container .exercise-day-item .exercise-day-content .exercise-item.expanded .exercise-edit-panel {
  padding: 8px 8px 8px 8px;
  opacity: 1;
}
.routine-panel .exercise-days-container .exercise-day-item .exercise-day-content .exercise-item .exercise-details {
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 100%;
  padding: 0 2px;
}
.routine-panel .exercise-days-container .exercise-day-item .exercise-day-content .exercise-item .exercise-details .details-row {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-2);
}
.routine-panel .exercise-days-container .exercise-day-item .exercise-day-content .exercise-item .exercise-details .details-row span {
  background-color: var(--surface-hover);
  padding: var(--space-0-5) var(--space-1);
  border-radius: 4px;
  white-space: nowrap;
  font-size: var(--font-size-xs);
}
.routine-panel .exercise-days-container .exercise-day-item .exercise-day-content .exercise-item .exercise-details .exercise-comment {
  display: block;
  font-style: italic;
  margin-top: 2px;
  color: var(--text-color-secondary);
  background-color: var(--surface-hover);
  padding: var(--space-1) var(--space-2);
  border-radius: 4px;
  font-size: var(--font-size-xs);
}
.routine-panel .exercise-days-container .exercise-day-item .exercise-day-content .exercise-item .exercise-form-fields {
  display: flex;
  flex-wrap: wrap;
  gap: 8px !important;
}
.routine-panel .exercise-days-container .exercise-day-item .exercise-day-content .exercise-item .exercise-form-fields .duplicate-warning {
  font-size: var(--font-size-xs);
  color: var(--text-color-secondary);
}
.routine-panel .exercise-days-container .exercise-day-item .exercise-day-content .exercise-item .exercise-form-fields .duplicate-warning i {
  font-size: var(--font-size-xs);
}
.routine-panel .exercise-days-container .exercise-day-item .exercise-day-content .exercise-item .exercise-form-fields .p-inputtext,
.routine-panel .exercise-days-container .exercise-day-item .exercise-day-content .exercise-item .exercise-form-fields .p-dropdown,
.routine-panel .exercise-days-container .exercise-day-item .exercise-day-content .exercise-item .exercise-form-fields .p-inputnumber {
  font-size: var(--font-size-base);
  width: 100%;
}
.routine-panel .exercise-days-container .exercise-day-item .exercise-day-content .exercise-item .exercise-form-fields .exercise-field {
  margin-bottom: 0;
  flex: 1 0 calc(25% - 8px);
  min-width: 65px;
}
.routine-panel .exercise-days-container .exercise-day-item .exercise-day-content .exercise-item .exercise-form-fields label {
  font-size: var(--font-size-xs);
}
.routine-panel .exercise-days-container .exercise-day-item .exercise-day-content .exercise-item .exercise-form-fields .comment-field {
  flex: 1 0 100%;
}
.routine-panel .exercise-days-container .exercise-day-item .exercise-day-content .exercise-item .exercise-form-fields .comment-field .p-inputtextarea {
  width: 100%;
  font-style: italic;
}
.routine-panel .exercise-days-container .exercise-day-item .exercise-day-content .exercise-item .exercise-form-fields > div:first-child {
  flex: 1 0 100%;
}
.routine-panel .exercise-days-container .exercise-day-item .exercise-day-content .exercise-item .exercise-form-fields.read-only-fields {
  padding: 4px;
}
.routine-panel .exercise-days-container .exercise-day-item .exercise-day-content .exercise-item .exercise-form-fields.read-only-fields .exercise-field-info {
  display: flex;
  flex-direction: column;
  flex: 1 0 calc(25% - 8px);
  min-width: 65px;
  background-color: var(--surface-hover);
  border-radius: var(--border-radius);
  padding: var(--space-2) var(--space-2);
}
.routine-panel .exercise-days-container .exercise-day-item .exercise-day-content .exercise-item .exercise-form-fields.read-only-fields .exercise-field-info .field-label {
  font-size: var(--font-size-xs);
  font-weight: var(--font-weight-semibold);
  color: var(--text-color-secondary);
  margin: 0 0 2px 0;
}
.routine-panel .exercise-days-container .exercise-day-item .exercise-day-content .exercise-item .exercise-form-fields.read-only-fields .exercise-field-info .field-value {
  font-size: var(--font-size-base);
  font-weight: var(--font-weight-medium);
  color: var(--text-color);
}
.routine-panel .exercise-days-container .exercise-day-item .exercise-day-content .exercise-item .exercise-form-fields.read-only-fields .exercise-field-info.comment-field {
  flex: 1 0 100%;
}
.routine-panel .exercise-days-container .exercise-day-item .exercise-day-content .exercise-item .exercise-form-fields.read-only-fields .exercise-field-info.comment-field .comment-value {
  font-style: italic;
  color: var(--text-color-secondary);
  max-height: 60px;
  overflow-y: auto;
  padding-right: 4px;
  position: relative;
}
.routine-panel .exercise-days-container .exercise-day-item .exercise-day-content .exercise-item .exercise-form-fields.read-only-fields .exercise-field-info.comment-field .comment-value::-webkit-scrollbar {
  width: 4px;
}
.routine-panel .exercise-days-container .exercise-day-item .exercise-day-content .exercise-item .exercise-form-fields.read-only-fields .exercise-field-info.comment-field .comment-value::-webkit-scrollbar-track {
  background-color: var(--surface-200);
  border-radius: 2px;
}
.routine-panel .exercise-days-container .exercise-day-item .exercise-day-content .exercise-item .exercise-form-fields.read-only-fields .exercise-field-info.comment-field .comment-value::-webkit-scrollbar-thumb {
  background-color: var(--border-strong);
  border-radius: 2px;
}
.routine-panel .exercise-days-container .exercise-day-item .exercise-day-content .exercise-item .exercise-form-fields.read-only-fields .exercise-field-info.comment-field .comment-value.has-overflow:after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 10px;
  background: linear-gradient(to top, var(--surface-hover) 0%, transparent 100%);
  pointer-events: none;
}
.routine-panel .exercise-days-container .exercise-day-item .exercise-day-content .exercise-item .exercise-form-fields.read-only-fields .exercise-data-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  width: 100%;
}
.routine-panel .exercise-days-container .exercise-day-item .exercise-day-content .exercise-item .exercise-form-fields.read-only-fields .exercise-name-value {
  font-weight: var(--font-weight-semibold);
  color: var(--accent);
  font-size: var(--font-size-base);
}
.routine-panel .exercise-days-container .exercise-day-item .exercise-day-content .no-exercises {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: var(--space-3);
  padding: 16px;
  text-align: center;
  background-color: var(--surface-ground);
  border-radius: var(--border-radius);
}
.routine-panel .exercise-days-container .exercise-day-item .exercise-day-content .no-exercises.error {
  background-color: var(--danger-subtle);
  border: 1px solid var(--danger);
}
.routine-panel .exercise-days-container .exercise-day-item .exercise-day-content .no-exercises.error i {
  color: var(--danger);
}
.routine-panel .exercise-days-container .exercise-day-item .exercise-day-content .no-exercises.error span {
  color: var(--danger);
}
.routine-panel .exercise-days-container .exercise-day-item .exercise-day-content .no-exercises.error .p-button-sm .p-button-label {
  color: var(--accent-text) !important;
}
.routine-panel .exercise-days-container .exercise-day-item .exercise-day-content .no-exercises.error .p-button-sm span {
  margin: 0;
}
.routine-panel .exercise-days-container .exercise-day-item .exercise-day-content .no-exercises.error .p-button-sm .p-button-icon {
  color: var(--accent-text) !important;
}
.routine-panel .exercise-days-container .exercise-day-item .exercise-day-content .no-exercises i {
  font-size: var(--font-size-lg);
  color: var(--text-color-secondary);
}
.routine-panel .exercise-days-container .exercise-day-item .exercise-day-content .no-exercises span {
  font-size: var(--font-size-xs);
  margin: 0 0 var(--space-2) 0;
}
.routine-panel .exercise-days-container .exercise-day-item .exercise-day-content .no-exercises .p-button-sm {
  margin-top: var(--space-2);
  font-size: var(--font-size-base);
}
.routine-panel .exercise-days-container .add-day-button {
  align-self: flex-start;
  margin-top: var(--space-2);
  font-size: var(--font-size-sm);
}

@media screen and (max-width: 480px) {
  .routine-panel .routine-panel-header h4 {
    margin-right: 0;
  }
  .routine-panel .routine-panel-header .next-routine-button {
    padding: 4px;
  }
  .routine-panel .routine-panel-header .next-routine-button .p-button-label {
    font-size: var(--font-size-xs);
  }
}
.exercise-day-draggable {
  transition: transform 0.2s, box-shadow 0.2s;
  margin-bottom: 0;
  width: 100%;
  height: auto;
  position: relative;
  display: flex;
  flex-direction: column;
}
@media screen and (max-width: 1400px) {
  .exercise-day-draggable {
    width: calc(33.33% - 8px);
  }
}
@media screen and (max-width: 1100px) {
  .exercise-day-draggable {
    width: calc(50% - 8px);
  }
}
@media screen and (max-width: 768px) {
  .exercise-day-draggable {
    width: calc(100% - 8px);
  }
}
.exercise-day-draggable.is-dragging {
  z-index: 9999 !important;
  box-shadow: var(--shadow-4);
  background-color: var(--accent-subtle);
  border-radius: var(--border-radius);
  transform: scale(1.05);
}
.exercise-day-draggable.is-dragging::after {
  content: "";
  display: block;
  height: 45.33px;
  width: 100%;
  position: absolute;
  bottom: -45.33px;
  left: 0;
  background-color: transparent;
  pointer-events: none;
}
.exercise-day-draggable.is-dragging .exercise-day-item {
  background-color: var(--accent-subtle);
  border: 2px dashed var(--primary-color);
}
.exercise-day-draggable.is-dragging .exercise-day-item .exercise-day-header {
  background-color: var(--accent-subtle);
}

.exercise-dropzone {
  min-height: 60px;
  border: none;
  flex: 1;
  display: flex;
  flex-direction: column;
  position: relative;
  z-index: 1;
}
.exercise-dropzone.is-dragging-over {
  opacity: 0.6;
}

.exercise-list {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
  flex: 1;
}

[data-rbd-placeholder-context-id] {
  opacity: 0.2 !important;
  min-width: 312px !important;
  background-color: var(--accent-subtle) !important;
  border: 1px dashed var(--border) !important;
  padding: 0 !important;
  margin: 4px 0 !important;
  max-width: 100% !important;
  pointer-events: none !important;
  border-radius: var(--border-radius);
}

body > [data-react-beautiful-dnd-draggable] {
  z-index: 9999 !important;
  min-width: 312px !important;
  overflow: hidden !important;
}

.exercise-item {
  position: relative;
  z-index: 1;
}
.exercise-item.is-dragging {
  z-index: 9999 !important;
  position: relative;
  box-shadow: var(--shadow-4) !important;
  transform: scale(1.05);
  height: auto !important;
  min-width: 312px !important;
  overflow: hidden !important;
  display: flex !important;
  align-items: center !important;
  background: var(--accent-subtle);
  border: 1px solid var(--primary-color);
  padding: 8px 12px;
  border-radius: var(--border-radius);
  box-shadow: var(--shadow-4);
}
.exercise-item.is-dragging .exercise-name {
  font-weight: var(--font-weight-bold) !important;
  color: var(--accent) !important;
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  max-height: 20px !important;
}

[data-rbd-draggable-id] {
  transition: transform 0.2s;
  position: relative;
  z-index: 1;
  width: 100%;
}
[data-rbd-draggable-id][data-rbd-dragging=true] {
  z-index: 9999 !important;
}

.drag-handle-day,
.drag-handle-exercise {
  cursor: grab;
  color: var(--text-color-secondary);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: color 0.2s, background-color 0.2s;
  width: 28px;
  height: 28px;
  border-radius: 4px;
  background-color: var(--surface-hover);
}
.drag-handle-day:hover,
.drag-handle-exercise:hover {
  color: var(--primary-color);
  background-color: var(--surface-100);
}
.drag-handle-day:active,
.drag-handle-exercise:active {
  cursor: grabbing;
  color: var(--primary-color);
  background-color: var(--surface-200);
}
.drag-handle-day i,
.drag-handle-exercise i {
  font-size: var(--font-size-sm);
}

.drag-handle-day {
  margin-right: 8px;
}

.drag-handle-exercise {
  margin-right: var(--space-2);
}
.drag-handle-exercise i {
  font-size: var(--font-size-xs);
}

.is-dragging {
  opacity: 0.85;
  box-shadow: var(--shadow-3);
  border: 1px dashed var(--primary-color) !important;
  background-color: var(--accent-subtle) !important;
}

.ReactModal__Overlay,
.ReactModalPortal,
[data-react-beautiful-dnd-portal] {
  z-index: 9999 !important;
}

[data-rbd-portal] {
  position: fixed;
  width: 0;
  height: 0;
  top: 0;
  left: 0;
  z-index: 9999 !important;
}

body.rbd-dragging * {
  z-index: 0; /* Establecer un z-index base a todos los elementos durante el arrastre */
}

body.rbd-body-dragging-active {
  cursor: grabbing !important;
}
body.rbd-body-dragging-active .exercise-days-view-grid {
  gap: var(--space-5) !important;
  transition: gap 0.2s ease;
}

.is-being-dragged {
  transition: none !important;
}

.superset-item {
  position: relative;
  padding: 0 !important;
  border-radius: none !important;
}
.superset-item .superset-content {
  display: flex;
  align-items: stretch;
}
.superset-item .superset-content:has(.superset-exercise-row.expanded) {
  border-radius: var(--border-radius);
  background: var(--surface-hover);
}
.superset-item .superset-content:has(.superset-exercise-row.expanded) .exercise-header,
.superset-item .superset-content:has(.superset-exercise-row.expanded) .exercise-edit-panel {
  border-radius: var(--border-radius);
}
.superset-item .superset-content.viewing-mode .exercise-header {
  padding: var(--space-2) var(--space-3);
}
.superset-item .superset-drag-handle {
  cursor: grab;
  color: var(--text-color-secondary);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: color 0.2s, background-color 0.2s;
  width: 28px;
  height: 28px;
  border-radius: 4px;
  background-color: var(--surface-hover);
  margin: auto var(--space-3);
  flex-shrink: 0;
}
.superset-item .superset-drag-handle:hover {
  color: var(--primary-color);
  background-color: var(--surface-100);
}
.superset-item .superset-drag-handle:active {
  cursor: grabbing;
  color: var(--primary-color);
  background-color: var(--surface-200);
}
.superset-item .superset-drag-handle i {
  font-size: var(--font-size-xs);
}
.superset-item .superset-exercises-container {
  flex: 1;
  display: flex;
  flex-direction: column;
}
.superset-item .superset-exercise-row {
  position: relative;
}
.superset-item .superset-exercise-row.first-exercise {
  border-bottom: 1px solid var(--surface-border);
  margin-bottom: 0px;
}
.superset-item .superset-exercise-row.second-exercise {
  margin-top: 0px;
}
.superset-item .superset-exercise-row .exercise-header {
  display: flex;
  align-items: center;
  padding: var(--space-2) var(--space-3) var(--space-2) 0;
  background: transparent;
  cursor: pointer;
  transition: all 0.2s;
}
.superset-item .superset-exercise-row .exercise-header .comment-indicator {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: var(--space-2);
}
.superset-item .superset-exercise-row .exercise-header .comment-indicator i {
  color: var(--accent);
  font-size: var(--font-size-xs);
}
.superset-item .superset-exercise-row .exercise-edit-panel {
  overflow: hidden;
  transition: max-height 0.3s ease, padding 0.3s ease, margin-top 0.3s ease;
  background: var(--surface-card);
}
.superset-item .superset-exercise-row.expanded .exercise-header {
  background: var(--surface-hover);
}
.superset-item .superset-exercise-row.expanded .exercise-header .comment-indicator {
  right: -4px;
  top: -4px;
}
.superset-item .superset-exercise-row.expanded .exercise-edit-panel {
  padding: 8px 8px 8px 0;
  opacity: 1;
  background: var(--surface-hover);
}
.superset-item .superset-break-button {
  position: absolute;
  top: 100%;
  left: calc(50% - 25px);
  transform: translateX(-50%);
  z-index: 10;
  background: var(--danger);
  color: var(--surface-raised);
  width: 24px;
  height: 24px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: var(--shadow-2);
  transition: all 0.3s ease;
  margin-top: -12px;
}
@media (hover: hover) and (pointer: fine) {
  .superset-item .superset-break-button {
    opacity: 0;
    visibility: hidden;
  }
}
@media (hover: none) and (pointer: coarse) {
  .superset-item .superset-break-button {
    opacity: 1;
    visibility: visible;
  }
}
.superset-item .superset-break-button:hover {
  background: var(--danger);
  transform: translateX(-50%) scale(1.1);
}
.superset-item .superset-break-button .p-button-icon {
  font-size: var(--font-size-2xs);
}
@media (hover: hover) and (pointer: fine) {
  .superset-item:hover .superset-break-button {
    opacity: 1;
    visibility: visible;
  }
}
.superset-item .exercise-view-icon {
  margin-right: 8px;
}
.superset-item .exercise-info {
  flex-grow: 1;
}
.superset-item .exercise-info .exercise-name {
  font-weight: var(--font-weight-medium);
  color: var(--text-color);
}
.superset-item .exercise-actions {
  display: flex;
  gap: 4px;
  margin-left: auto;
}

.superset-panel {
  background-color: var(--surface-ground);
  border-radius: var(--border-radius);
  padding: 12px;
  position: relative;
}
.superset-panel .superset-exercises {
  display: flex;
  flex-direction: column;
  gap: 12px;
  position: relative;
}

.superset-exercise-item {
  background: var(--surface-card);
  border: 1px solid var(--surface-border);
  border-radius: var(--border-radius);
  padding: var(--space-3) var(--space-3);
  position: relative;
}
.superset-exercise-item::before {
  content: "";
  position: absolute;
  left: -2px;
  top: 8px;
  bottom: 8px;
  width: 2px;
  background-color: var(--border-strong);
  border-radius: 1px;
}
.superset-exercise-item:not(:last-child)::after {
  content: "";
  position: absolute;
  bottom: -6px;
  left: 50%;
  transform: translateX(-50%);
  width: 20px;
  height: 2px;
  background: var(--border-strong);
  border-radius: 1px;
}
.superset-exercise-item .superset-exercise-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
}
.superset-exercise-item .superset-exercise-header .exercise-info {
  flex: 1;
  min-width: 0;
}
.superset-exercise-item .superset-exercise-header .exercise-info .exercise-name {
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-medium);
  color: var(--text-color);
  display: block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.superset-exercise-item .superset-exercise-form {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.superset-exercise-item .superset-exercise-form .exercise-field {
  margin-bottom: 0;
  flex: 1 0 calc(25% - 8px);
  min-width: 60px;
}
.superset-exercise-item .superset-exercise-form .comment-field {
  flex: 1 0 100%;
}
.superset-exercise-item .superset-exercise-form .comment-field .p-inputtextarea {
  width: 100%;
  font-style: italic;
  font-size: var(--font-size-xs);
}
.superset-exercise-item .superset-exercise-form > div:first-child {
  flex: 1 0 100%;
}

.exercise-item {
  position: relative;
}
.exercise-item .create-superset-button-top {
  position: absolute;
  top: -21px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 10;
  width: 28px;
  height: 28px;
  background-color: var(--surface-card);
  border: 2px solid var(--border-strong);
  border-radius: 50%;
  color: var(--accent);
  box-shadow: var(--shadow-3);
  transition: all 0.2s ease;
}
@media (hover: none) and (pointer: coarse) {
  .exercise-item .create-superset-button-top {
    opacity: 1;
  }
}
@media (hover: hover) and (pointer: fine) {
  .exercise-item .create-superset-button-top {
    opacity: 0;
  }
}
.exercise-item .create-superset-button-top:hover {
  background-color: var(--accent);
  color: var(--accent-text);
  border-color: var(--accent);
  transform: translateX(-50%) scale(1.1);
}
.exercise-item .create-superset-button-top .p-button-icon {
  font-size: var(--font-size-xs);
}
.exercise-item .create-superset-button-bottom {
  position: absolute;
  bottom: -21px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 10;
  width: 28px;
  height: 28px;
  background-color: var(--surface-card);
  border: 2px solid var(--border-strong);
  border-radius: 50%;
  color: var(--accent);
  box-shadow: var(--shadow-3);
  transition: all 0.2s ease;
}
@media (hover: none) and (pointer: coarse) {
  .exercise-item .create-superset-button-bottom {
    opacity: 1;
  }
}
@media (hover: hover) and (pointer: fine) {
  .exercise-item .create-superset-button-bottom {
    opacity: 0;
  }
}
.exercise-item .create-superset-button-bottom:hover {
  background-color: var(--accent);
  color: var(--accent-text);
  border-color: var(--accent);
  transform: translateX(-50%) scale(1.1);
}
.exercise-item .create-superset-button-bottom .p-button-icon {
  font-size: var(--font-size-xs);
}
@media (hover: hover) and (pointer: fine) {
  .exercise-item.can-create-superset-prev:hover .create-superset-button-top {
    opacity: 1;
  }
  .exercise-item.can-create-superset-next:hover .create-superset-button-bottom {
    opacity: 1;
  }
}
.exercise-item.can-create-superset-prev, .exercise-item.has-disabled-superset-prev {
  margin-top: 0px;
}
.exercise-item.can-create-superset-next, .exercise-item.has-disabled-superset-next {
  margin-bottom: 0px;
}

.exercise-item.can-create-superset-prev,
.exercise-item.can-create-superset-next {
  border-left: 3px solid var(--border);
}
.exercise-item.can-create-superset-prev:hover,
.exercise-item.can-create-superset-next:hover {
  border-left-color: var(--border-strong);
}

.exercise-item:hover .superset-button {
  opacity: 0;
  pointer-events: none;
}

.disabled-superset-button {
  z-index: 15;
  background: var(--danger-subtle);
  border: 1px solid var(--danger);
  color: var(--danger);
}
.disabled-superset-button:hover {
  background: var(--danger-subtle);
  border-color: var(--danger);
  color: var(--danger);
}
@media (hover: hover) and (pointer: fine) {
  .disabled-superset-button {
    opacity: 0;
  }
  .exercise-item:hover .disabled-superset-button {
    opacity: 1;
  }
}
@media (hover: none) and (pointer: coarse) {
  .disabled-superset-button {
    opacity: 1;
  }
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};
